<script lang="ts">
import { I3pService } from '../../services/i3p.service'
import { I3pEventsEnum } from '../../types/I3pEvents.enum'

export default {
    name: 'I3p',
    props: {
        i3pService: { type: I3pService, required: true },
    },
    emits: [],
    data() {
        return {
            showEntityContent: true,
        }
    },
    computed: {},
    watch: {},
    mounted() {
        this.i3pService.emitter
            .on(I3pEventsEnum.currentEntityUpdated, (/* event: { currentEntity: BaseModel<any> } */) => {
                this.showEntityContent = true
            })

        this.i3pService.emitter
            .on(I3pEventsEnum.switchEditMode, (event: { editMode: boolean }) => {
                if (event.editMode)
                    this.showEntityContent = true
            })
    },
    methods: {},
}
</script>

<template>
    <client-only>
        <div v-if="$slots.topButtons" class="w-100 mb-2">
            <slot name="topButtons" />
        </div>
        <v-row>
            <v-col cols="12" :lg="showEntityContent ? 8 : 12" :md="showEntityContent ? 6 : 12" class="position-relative pr-6">
                <slot name="map-panel" />
                <div v-if="$vuetify.display.mdAndUp" id="entity-panel-expansion-arrow" class="mt-3">
                    <v-btn
                        :icon="showEntityContent ? 'mdi-arrow-right' : 'mdi-arrow-left'"
                        color="primary" size="x-small" rounded="0" variant="flat" class="px-0"
                        aria-label="Rétrécir ou agrandir le panneau latéral"
                        @click="showEntityContent = !showEntityContent; i3pService.resizeMap()"
                    />
                </div>
                <slot name="list-panel" />
            </v-col>
            <v-col cols="12" lg="4" md="6" class="px-0" :style="{ display : showEntityContent || $vuetify.display.smAndDown ? 'initial' : 'none'}">
                <v-card id="entity-panel" class="pa-4 overflow-visible" :class="{'h-100': $vuetify.display.mdAndUp && !showEntityContent, 'rounded-t-0 ml-3 has-border' :$vuetify.display.mdAndUp }">
                    <!-- ARROW TO SHOW/HIDE PANEL -->
                    <slot name="entity-panel" />
                </v-card>
            </v-col>
        </v-row>
        <div v-if="$slots.bottomButtons" class="w-100 mb-2">
            <slot name="bottomButtons" />
        </div>
    </client-only>
</template>
